import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MenuItem, TextField } from '@mui/material';
import { AppDispatch } from '../../reduxStore/Store';
import { fetchReportTemplateData } from '../../reduxStore/ReportTemplateSlice';
import { ReportTemplate } from '../../models/models';

interface Props {
  value: number | null;
  onChange: (templateId: number | null, template: ReportTemplate | null) => void;
  typeRapport?: string | null;
  label?: string;
  fullWidth?: boolean;
  required?: boolean;
}

const SelectReportTemplate: React.FC<Props> = ({
  value, onChange, typeRapport, label = 'Template', fullWidth = true, required = false,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { reportTemplateData } = useSelector((state: any) => state.ReportTemplateSlice);

  useEffect(() => {
    dispatch(fetchReportTemplateData({ type_rapport: typeRapport ?? null, limit: 100, offset: 0 }));
  }, [dispatch, typeRapport]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const id = e.target.value === '' ? null : Number(e.target.value);
    const tpl = id ? reportTemplateData.find((t: ReportTemplate) => t.id === id) ?? null : null;
    onChange(id, tpl);
  };

  return (
    <TextField
      select
      label={label}
      value={value ?? ''}
      onChange={handleChange}
      fullWidth={fullWidth}
      required={required}
      size="small"
    >
      <MenuItem value=""><em>Template par défaut</em></MenuItem>
      {reportTemplateData.map((t: ReportTemplate) => (
        <MenuItem key={t.id} value={t.id}>
          {t.nom}{t.is_default ? ' ★' : ''}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default SelectReportTemplate;
